"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Bucket_1 = require("../entity/Bucket");
class StubBucket extends Bucket_1.default {
    constructor({ id = '123' } = {}) {
        super({ id });
    }
}
exports.default = StubBucket;
